<template>
  <div class="row jipvio-dashboard">
    <div class="col-12">
      <card class="mt-70" card-body-classes="table-full-width" no-footer-line>
        <h4 class="card-title ml-20">매물관리</h4>
        <div class="F_Menu ml-30">
          <ul class="F_Menu_Select row pb-0">
            <li class="mr-10" v-for="(btn, index) in btnNameList1" :key="index">
              <el-Radio
                v-model="btnRadio1"
                :label="btn.label"
                border
                @click="
                  state = btn.value;
                  getPropertyMgmt();
                "
                >{{ btn.label }}</el-Radio
              >
            </li>
          </ul>
          <ul class="F_Menu_Select row  px-0 mr-0 mb-30">
            <li class="mr-10" v-for="(btn, index) in btnNameList2" :key="index">
              <el-Radio
                @click="
                  propType = btn.value;
                  getPropertyMgmt();
                "
                v-model="btnRadio2"
                :label="btn.label"
                border
                >{{ btn.label }}</el-Radio
              >
            </li>
          </ul>
        </div>
        <card>
          <h4 class="card-title ml-20 mb-30">매물관리 > {{ btnRadio1 }}</h4>
          <div
            class="d-flex justify-content-center justify-content-sm-between flex-wrap"
          >
            <el-select
              class="select-primary mb-3 ml-20"
              style="width: 200px"
              v-model="pagination.perPage"
              placeholder="Per page"
            >
              <el-option
                class="select-default"
                v-for="item in pagination.perPageOptions"
                :key="item"
                :label="item"
                :value="item"
              >
              </el-option>
            </el-select>

            <fg-input class="mr-30">
              <el-popover
                class="fl mr-10"
                placement="bottom-start"
                width="70"
                trigger="click"
              >
                <el-checkbox
                  v-for="tc in tableColumns"
                  :key="tc.label"
                  :label="tc.label"
                  v-model="tc.vif"
                ></el-checkbox>

                <el-button class="pr-2 pl-2" slot="reference"
                  >필터 <i class="fas fa-angle-down"></i
                ></el-button>
              </el-popover>

              <el-select
                class="select-primary mb-3 fl mr-10"
                style="width: 200px"
                v-model="searchStd"
                placeholder="검색기준"
                @input="searchSetData(searchStd)"
              >
                <el-option
                  class="select-default"
                  v-for="tc in tableColumns"
                  :key="tc.label"
                  :label="tc.label"
                  :value="tc.label"
                >
                </el-option>
              </el-select>
              <el-autocomplete
                type="search"
                class="mb-3 fl"
                clearable
                style="width: 200px"
                placeholder="Search records"
                v-model="searchQuery"
                aria-controls="datatables"
                :fetch-suggestions="querySearchAsync"
                @select="handleSelect"
              >
              </el-autocomplete>
            </fg-input>
          </div>
          <el-table class="col-10" stripe :data="tableData">
            <el-table-column
              v-for="column in filteredColumns()"
              :key="column.label"
              :min-width="column.minWidth"
              :prop="column.prop"
              :label="column.label"
              align="center"
              :sortable="column.sortable"
            >
            </el-table-column>

            <el-table-column
              :min-width="135"
              fixed="right"
              label="작업"
              align="center"
            >
              <template v-slot="props">
                <div class="table-actions">
                  <n-button
                    @click.native="createPdfFile()"
                    class="like"
                    type="info"
                    size="sm"
                    round
                    icon
                  >
                    <i class="jipvio-ui-icons-document"></i>
                  </n-button>
                  <n-button
                    @click.native="handleEdit(props.$index, props.row)"
                    class="edit"
                    type="warning"
                    size="sm"
                    round
                    icon
                  >
                    <i class="jipvio-ui-icons-pen"></i>
                  </n-button>
                  <n-button
                    @click.native="printData(props.$index, props.row)"
                    class="remove"
                    type="danger"
                    size="sm"
                    round
                    icon
                  >
                    <i class="fa fa-times"></i>
                  </n-button>
                </div>
              </template>
            </el-table-column>
          </el-table>
          <div
            class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
          >
            <div>
              <p class="card-category">
                Showing {{ from + 1 }} to {{ to }} of {{ total }} entries
              </p>
            </div>
            <n-pagination
              class="pagination-no-border"
              v-model="pagination.currentPage"
              :per-page="pagination.perPage"
              :total="pagination.totalCnt"
            >
            </n-pagination>
          </div>
        </card>
      </card>
    </div>
  </div>
</template>
<script>
import {
  Table,
  TableColumn,
  Select,
  Option,
  Input,
  Button,
  Radio,
  Popover,
  Checkbox,
  Autocomplete,
  CheckboxGroup
} from "element-ui";
import { Pagination as NPagination } from "@/components";
import { Button as NButton } from "@/components";
import card from "@/components/Cards/Card.vue";
import propApi from "@/service/property";
import contApi from "@/service/contract";

import { createNamespacedHelpers } from "vuex";

import fontNanumBarunGothic from "@/assets/fonts/NanumBarunGothic.js";
import fontNanumBarunGothicBold from "@/assets/fonts/NanumBarunGothicBold.js";

import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
pdfMake.vfs = pdfFonts.pdfMake.vfs;

const {
  mapGetters: sessionMapGetters,
  mapActions: sessionMapActions
} = createNamespacedHelpers("loginSession");

export default {
  components: {
    NPagination,
    NButton,
    card,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Input.name]: Input,
    [Button.name]: Button,
    [Radio.name]: Radio,
    [Popover.name]: Popover,
    [Checkbox.name]: Checkbox,
    [Autocomplete.name]: Autocomplete,
    [CheckboxGroup.name]: CheckboxGroup
  },
  created() {
    console.log("======매물관리");
    console.log(this.sessionUserInfo);

    this.imgPath = `http://${window.location.host}/img`;
    this.applyCommonCode();
    if (this.sessionUserInfo.type == "LO") {
      this.btnNameList1 = {
        request: {
          label: "의뢰단계",
          value: "RQ"
        },
        open: {
          label: "노출중",
          value: "OP"
        },
        close: {
          label: "노출종료",
          value: "EX"
        }
      };

      this.state = "RQ";
      this.propType = "APT";

      this.getPropertyMgmt();
    } else if (this.sessionUserInfo.type == "AG") {
      this.btnNameList1 = {
        request: {
          label: "검수요청",
          value: "CHS"
        },
        open: {
          label: "노출중",
          value: "OP"
        },
        close: {
          label: "노출종료",
          value: "EX"
        }
      };

      this.state = "CHS";
      this.propType = "APT";

      this.getPropertyMgmt();
    }
  },

  computed: {
    ...sessionMapGetters({
      sessionUserInfo: "getUserInfo",
      sessionCoCodeMap: "getCoCodeMap"
    }),
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total() {
      return this.pagination.totalCnt;
    }
  },
  data() {
    return {
      btnRadio1: "",
      btnRadio2: "",

      btnNameList1: {},
      btnNameList2: {
        apt: {
          label: "아파트",
          value: "APT"
        },
        vil: {
          label: "빌라",
          value: "VLL"
        },
        ho: {
          label: "주택",
          value: "HOM"
        },
        op: {
          label: "오피스텔",
          value: "OPS"
        },
        or: {
          label: "원룸",
          value: "OM"
        }
      },
      pagination: {
        perPage: 5,
        currentPage: 1,
        perPageOptions: [5, 10, 25, 50],
        totalCnt: 0,
        totalPages: 10
      },
      searchStd: null,
      searchData: [],
      searchQuery: "",

      tableColumns: {
        CTT: {
          prop: "formattedPTT",
          label: "거래형태",
          minWidth: 125,
          sortable: true,
          vif: true
        },
        purpsCd: {
          prop: "formattedType",
          label: "종류",
          minWidth: 100,
          sortable: true,
          vif: true
        },
        bldNm: {
          prop: "name",
          label: "건물명",
          minWidth: 110,
          sortable: true,
          vif: true
        },
        dong: {
          prop: "newAddr",
          label: "법정동",
          minWidth: 110,
          sortable: true,
          vif: true
        },
        JiBun: {
          prop: "newAddr",
          label: "지번",
          minWidth: 100,
          sortable: true,
          vif: true
        },
        area: {
          prop: "useArea",
          label: "면적",
          minWidth: 100,
          sortable: true,
          vif: true
        },
        deposit: {
          prop: "formattedDeposit",
          label: "보증금",
          minWidth: 110,
          sortable: true,
          vif: true
        },
        monthlyPay: {
          prop: "formattedPayment",
          label: "월세",
          minWidth: 100,
          sortable: true,
          vif: true
        },
        possibleMoveDate: {
          prop: "formattedMDT",
          label: "입주가능일",
          minWidth: 150,
          sortable: true,
          vif: true
        },
        updatedDate: {
          prop: "formattedUDT",
          label: "등록일",
          minWidth: 110,
          sortable: true,
          vif: true
        },
        extraInfo: {
          prop: "updatedDate",
          label: "추가설명",
          minWidth: 125,
          sortable: false,
          vif: true
        }
      },
      tableData: null,

      propType: null,
      state: null,

      selects: {
        PTTMap: [],
        BPPMap: []
      },

      contInfo: null,
      imgPath: null,
      timeout: null
    };
  },
  methods: {
    searchSetData(value) {
      let selectData = [];
      if (value == "거래형태") {
        console.log(value);
        this.tableData.forEach((ele, dex) => {
          selectData.push(ele.formattedPTT);
        });
      } else if (value == "종류") {
        console.log(value);
        this.tableData.forEach((ele, dex) => {
          selectData.push(ele.formattedType);
        });
      } else if (value == "건물명") {
        console.log(value);
        this.tableData.forEach((ele, dex) => {
          selectData.push(ele.name);
        });
      } else if (value == "법정동") {
        console.log(value);
        this.tableData.forEach((ele, dex) => {
          selectData.push(ele.newAddr);
        });
      } else if (value == "지번") {
        console.log(value);
        this.tableData.forEach((ele, dex) => {
          selectData.push(ele.useArea);
        });
      } else if (value == "면적") {
        console.log(value);
        this.tableData.forEach((ele, dex) => {
          selectData.push(ele.userArea);
        });
      } else if (value == "보증금") {
        console.log(value);
        this.tableData.forEach((ele, dex) => {
          selectData.push(String(ele.formattedDeposit));
        });
      } else if (value == "월세") {
        console.log(value);
        this.tableData.forEach((ele, dex) => {
          selectData.push(String(ele.formattedPayment));
        });
      } else if (value == "입주가능일") {
        console.log(value);
        this.tableData.forEach((ele, dex) => {
          selectData.push(ele.formattedUDT);
        });
      } else if (value == "등록일") {
        console.log(value);
        this.tableData.forEach((ele, dex) => {
          selectData.push(ele.updatedDate);
        });
      } else if (value == "추가설명") {
        console.log(value);
        this.tableData.forEach((ele, dex) => {
          selectData.push(ele.extraInfo);
        });
      }

      /* 중복 확인 및 제거 */
      selectData = Array.from(new Set(selectData));

      /* value값으로 만들어 주지 않으면 읽지 못함 */
      if (selectData.length > 0) {
        let values = [];
        for (let i = 0; i < selectData.length; i++) {
          values.push({
            label: value,
            value: selectData[i]
          });
        }
        this.searchData = values;
      }
      console.log("=======================this.searchData");
      console.log(this.searchData);
    },

    querySearchAsync(queryString, cb) {
      let searchResult = this.searchData;

      let results = queryString
        ? searchResult.filter(this.createFilter(queryString))
        : searchResult;

      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        cb(results);
      }, 300);
    },
    createFilter(queryString) {
      return el => {
        return el.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0;
      };
    },
    handleSelect(item) {
      console.log("=================handleSelect");
      if (this.searchStd == "거래형태") {
        this.propType = item.value;
      } else if (this.searchStd == "종류") {
        this.bldTypeCode = item.value;
      }
      // this.getAllProperty();
    },

    printData(index, row) {
      let indexToDelete = this.tableData.findIndex(
        tableRow => tableRow.id === row.id
      );
      console.log("here");
      console.log(index);
      console.log(row);
      console.log(indexToDelete);
    },
    // handleEdit(index, row) {
    //   Swal.fire({
    //     title: `You want to edit ${row.name}`,
    //     buttonsStyling: false,
    //     confirmButtonClass: "btn btn-info btn-fill"
    //   });
    // },
    handleEdit(index, row) {
      if (this.sessionUserInfo.type == "LO") {
        this.$router.push({
          path: "/mypage/admin/ppt/ler/detail"
          // query: { x: this.x, y: this.y }
        });
      } else if (this.sessionUserInfo.type == "AG") {
        this.$router.push({
          path: "/mypage/admin/ppt/agt/detail"
          // query: { x: this.x, y: this.y }
        });
      }
    },
    handleDelete(index, row) {
      Swal.fire({
        title: "Are you sure?",
        text: `You won't be able to revert this!`,
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "btn btn-success btn-fill",
        cancelButtonClass: "btn btn-danger btn-fill",
        confirmButtonText: "Yes, delete it!",
        buttonsStyling: false
      }).then(result => {
        if (result.value) {
          this.deleteRow(row);
          Swal.fire({
            title: "Deleted!",
            text: `You deleted ${row.name}`,
            type: "success",
            confirmButtonClass: "btn btn-success btn-fill",
            buttonsStyling: false
          });
        }
      });
    },
    deleteRow(row) {
      let indexToDelete = this.tableData.findIndex(
        tableRow => tableRow.id === row.id
      );
      if (indexToDelete >= 0) {
        this.tableData.splice(indexToDelete, 1);
      }
    },

    applyCommonCode() {
      //PTT========================================================
      this.sessionCoCodeMap.PTT.forEach((ele, dex) => {
        this.selects.PTTMap[ele.code] = ele.name;
      });

      //BPP========================================================
      this.sessionCoCodeMap.BPP.forEach((ele, dex) => {
        this.selects.BPPMap[ele.code] = ele.name;
      });
    },
    formatMoney(money) {
      const moneyVal = money < 0 ? false : money;
      const unitWords = ["원", "만원", "억", "조", "경"];
      const splitUnit = 10000;
      const splitCount = unitWords.length;
      let resultArray = [];
      let resultString = "";

      for (var i = 0; i < splitCount; i++) {
        var unitResult =
          (moneyVal % Math.pow(splitUnit, i + 1)) / Math.pow(splitUnit, i);
        unitResult = Math.floor(unitResult);
        if (unitResult > 0) {
          resultArray[i] = unitResult;
        }
      }
      for (var i = 0; i < resultArray.length; i++) {
        if (!resultArray[i]) continue;
        resultString = String(resultArray[i]) + unitWords[i] + resultString;
      }

      return resultString.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },

    async getPropertyMgmt() {
      const GbInfo = {
        pageNo: this.pagination.currentPage - 1,
        sizePerPage: this.pagination.perPage,
        propType: this.propType,
        state: this.state
      };

      const res = await propApi.getPropertyMgmt(GbInfo);

      console.log("-----------------------");
      console.log(res);

      this.pagination.perPage = res.pagingInfo.size;
      this.pagination.currentPage = res.pagingInfo.pageNo + 1;
      this.pagination.totalCnt = res.pagingInfo.totalCnt;
      this.pagination.totalPages = res.pagingInfo.totalPages;
      this.tableData = res.payload;

      for (let i = 0; i < this.tableData.length; i++) {
        this.tableData[i].formattedMDT = this.$moment(
          this.tableData[i].moveDt
        ).format("YYYY-MM-DD");

        this.tableData[i].formattedPTT = this.selects.PTTMap[
          this.tableData[i].paymentType
        ];
        this.tableData[i].formattedType = this.selects.BPPMap[
          this.tableData[i].type
        ];

        this.tableData[i].formattedDeposit = this.formatMoney(
          this.tableData[i].deposit
        );

        this.tableData[i].formattedPayment = this.formatMoney(
          this.tableData[i].payment
        );

        this.tableData[i].formattedUDT = this.$moment(
          this.tableData[i].updatedDate
        ).format("YYYY-MM-DD");
      }

      console.log(this.tableData);
    },

    filteredColumns() {
      const newTbColumns = _.cloneDeep(this.tableColumns);
      for (let key in newTbColumns) {
        if (newTbColumns[key].vif == false) {
          delete newTbColumns[key];
        }
      }
      return newTbColumns;
    },

    async getContractDetail(id) {
      const res = await contApi.getContractDetail(id);

      this.contInfo = res.payload;
      console.log("-----------------cont");
      console.log(res);
      console.log(this.contInfo);
    },

    changeLine(value, max) {
      if (value == null) {
        return null;
      } else if (value.length > max) {
        return value.substr(0, max) + "\n" + value.substr(max);
      } else {
        return value;
      }
    },
    modifiedMonthlyPay(mp) {
      if (mp == null || mp == "") {
        return null;
      } else {
        return "월세: " + mp + "원";
      }
    },
    //pdf=======================================================
    async createPdfFile() {
      await this.getContractDetail(42);

      const brokerAddr = "서울시 구로구 고척로 89, 1층 일부"; //공인중개사 주소
      const brokerName = "유소현"; //공인중개사 이름
      const companyName = "집비오부동산중개"; //상호(명칭)
      const brokerResNum = "제11530-2020-00050호"; //공인중개서 등록번호
      const brokerBirth = "1991년 05월 17일"; //공인중개사 생년월일
      const brokerTel = "02-2688-3244 / 010-4968-4919"; //공인중개사 전화번호

      pdfMake.vfs.NanumBarunGothic = fontNanumBarunGothic[0].NanumBarunGothic;
      pdfMake.vfs.NanumBarunGothicBold =
        fontNanumBarunGothicBold[0].NanumBarunGothicBold;

      pdfMake.fonts = {
        NanumBarunGothic: {
          normal: "NanumBarunGothic",
          bold: "NanumBarunGothicBold",
          italics: "NanumBarunGothic",
          bolditalics: "NanumBarunGothicBold"
        }
      };
      let docDefinition = {
        pageSize: "A4",
        //pageOrientation: "landscape",
        //pageMargins: [40, 60, 40, 60],
        defaultStyle: {
          font: "NanumBarunGothic"
        },

        background: function(page) {
          if (page == 1) {
            return [
              {
                image: "contract1",
                fit: [600, 2000]
              }
            ];
          } else if (page == 2) {
            return [
              {
                image: "contract2",
                fit: [600, 2000]
              }
            ];
          } else {
            return [
              {
                image: "contract3",
                fit: [600, 2000]
              }
            ];
          }
        },
        content: [
          {
            // 임대 체크박스
            text: "V",
            // fontSize: 50,
            absolutePosition: { x: 227, y: 110 }
          },
          {
            // 공개 비공개 여부
            text: "공개",
            fontSize: 9,
            absolutePosition: { x: 174, y: 244.5 }
          },
          {
            // 계약 유효기간 년도
            text: this.$moment(this.contInfo.expireDate).format("YYYY"),
            fontSize: 9,
            absolutePosition: { x: 185, y: 413.5 }
          },
          {
            // 계약 유효기간 월
            text: this.$moment(this.contInfo.expireDate).format("MM"),
            fontSize: 9,
            absolutePosition: { x: 239, y: 413.5 }
          },

          {
            // 계약 유효기간 일
            text: this.$moment(this.contInfo.expireDate).format("DD"),
            fontSize: 9,
            absolutePosition: { x: 276, y: 413.5 }
          },
          {
            // 중개보수 %
            text: this.contInfo.brokeRate,
            fontSize: 9,
            absolutePosition: { x: 334, y: 455 }
          },
          {
            // 중개보수 원
            text: this.contInfo.brokePrice,
            fontSize: 9,
            absolutePosition: { x: 375, y: 444 }
          },
          // {
          //   // 작성일 년도
          //   text: this.today.year,
          //   fontSize: 9,
          //   absolutePosition: { x: 426, y: 605.5 }
          // },
          // {
          //   // 작성일 월
          //   text: this.today.month,
          //   fontSize: 9,
          //   absolutePosition: { x: 477, y: 605.5 }
          // },
          // {
          //   // 작성일 일
          //   text: this.today.date,
          //   fontSize: 9,
          //   absolutePosition: { x: 515, y: 605.5 }
          // },
          {
            // 중개의뢰인 주소
            text: this.changeLine(this.contInfo.clientAddr, 25),
            fontSize: 8,
            absolutePosition: { x: 183, y: 644 }
          },
          {
            // 중개의뢰인 성명
            text: this.contInfo.clientName,
            fontSize: 9,
            absolutePosition: { x: 420, y: 647 }
          },
          // // {
          // //   // 중개의뢰인 서명란
          // //   image: this.imageUrl,
          // //   width: 150,
          // //   height: 150,
          // //   absolutePosition: { x: 450, y: 647 },
          // // },
          {
            // 중개의뢰인 생년월일
            text: this.contInfo.clientBirthDate,
            fontSize: 9,
            absolutePosition: { x: 185, y: 670 }
          },
          {
            // 중개의뢰인 전화번호
            text: this.contInfo.clientContactNum,
            fontSize: 9,
            absolutePosition: { x: 420, y: 670 }
          },
          {
            // 개업 공인중개사 주소
            text: brokerAddr,
            fontSize: 9,
            absolutePosition: { x: 185, y: 694 }
          },
          {
            // 개업 공인중개사 성명
            text: brokerName,
            fontSize: 9,
            absolutePosition: { x: 420, y: 694 }
          },
          {
            // 개업 공인중개사 상호
            text: companyName,
            fontSize: 9,
            absolutePosition: { x: 185, y: 717 }
          },
          {
            // 개업 공인중개사 등록번호
            text: brokerResNum,
            fontSize: 9,
            absolutePosition: { x: 420, y: 717 }
          },
          {
            // 개업 공인중개사 생년월일
            text: brokerBirth,
            fontSize: 9,
            absolutePosition: { x: 185, y: 740 }
          },
          {
            // 개업 공인중개사 전화번호
            text: brokerTel,
            fontSize: 9,
            absolutePosition: { x: 420, y: 737 }
          },
          {
            text: "",
            pageBreak: "after"
          },

          // //2페이지===========================================================
          {
            //권리이전용 임대 체크박스
            text: "V",
            absolutePosition: { x: 203, y: 169 }
          },
          {
            //소유자 및 등기명의인 성명
            text: this.contInfo.clientName,
            fontSize: 9,
            absolutePosition: { x: 170, y: 192 }
          },
          {
            //소유자 및 등기명의인 생년월일
            text: this.contInfo.clientBirthDate,
            fontSize: 9,
            absolutePosition: { x: 415, y: 192 }
          },
          {
            //소유자 및 등기명의인 주소
            text: this.contInfo.clientAddr,
            fontSize: 8,
            absolutePosition: { x: 170, y: 216 }
          },
          // {
          //   //중개대상물 (건축물) 소재지
          //   text: this.ModifiedBuildingAddr,
          //   fontSize: 8,
          //   absolutePosition: { x: 208, y: 240 }
          // },
          // {
          //   //중개대상물 (건축물) 건축년도
          //   text: this.certification.buildYear,
          //   fontSize: 9,
          //   absolutePosition: { x: 475, y: 244 }
          // },
          // {
          //   //중개대상물 (건축물) 면적
          //   text: this.finalUseArea,
          //   fontSize: 9,
          //   absolutePosition: { x: 208, y: 268 }
          // },
          // {
          //   //중개대상물 (건축물) 구조
          //   text: this.certification.strct,
          //   fontSize: 9,
          //   absolutePosition: { x: 335, y: 268 }
          // },
          // {
          //   //중개대상물 (건축물) 용도
          //   text: this.certification.purpsDetail,
          //   fontSize: 9,
          //   absolutePosition: { x: 465, y: 268 }
          // },
          // {
          //   //중개대상물 (토지) 소재지
          //   text: this.ModifiedLandAddr,
          //   fontSize: 8,
          //   absolutePosition: { x: 208, y: 289 }
          // },
          // {
          //   //중개대상물 (토지) 지목
          //   text: this.certification.platGbCdNm,
          //   fontSize: 9,
          //   absolutePosition: { x: 465, y: 291 }
          // },
          // {
          //   //중개대상물 (토지) 면적
          //   text: this.certification.platArea,
          //   fontSize: 9,
          //   absolutePosition: { x: 208, y: 316 }
          // },
          // {
          //   //중개대상물 (토지) 지역,지구 등
          //   text: this.modifiedbrdList,
          //   fontSize: 8,
          //   absolutePosition: { x: 344, y: 313 }
          // },
          // {
          //   //중개대상물 (토지) 현재 용도
          //   text: this.certification.platGbCdNm,
          //   fontSize: 9,
          //   absolutePosition: { x: 480, y: 316 }
          // },
          // {
          //   //중개대상물 - 은행융자, 권리금, 제세공과금 등
          //   text: this.otherFee,
          //   fontSize: 9,
          //   absolutePosition: { x: 147, y: 351 }
          // },
          {
            //권리관계
            text: this.contInfo.relation,
            fontSize: 9,
            absolutePosition: { x: 147, y: 389 }
          },
          {
            //거래규제 및 공법상 제한사항
            text: this.contInfo.regulation,
            fontSize: 8,
            absolutePosition: { x: 147, y: 410 }
          },
          // {
          //   //전세 or 월세
          //   text: this.paymentTypeStr,
          //   fontSize: 9,
          //   absolutePosition: { x: 143, y: 438 }
          // },
          {
            //중개의뢰 금액 (보증금)
            text: "보증금: " + this.contInfo.deposit,
            fontSize: 9,
            absolutePosition: { x: 240, y: 438 }
          },
          {
            //중개의뢰 금액 (월세)
            text: this.modifiedMonthlyPay(this.contInfo.payment),
            fontSize: 9,
            absolutePosition: { x: 400, y: 438 }
          },
          {
            //그 밖의 사항
            text: this.contInfo.etc,
            fontSize: 8,
            absolutePosition: { x: 147, y: 459 }
          },

          {
            text: "",
            pageBreak: "after"
          },
          // //3페이지===============================================================
          {
            // 매매 교환 9억원 이상
            text: 9,
            fontSize: 9,
            absolutePosition: { x: 210, y: 287.5 }
          },
          {
            //임대차 등(매매 교환 이외) 6억원 이상
            text: 8,
            fontSize: 9,
            absolutePosition: { x: 210, y: 415 }
          },
          {
            //오피스텔 적용대상 외의 경우 상한 요율
            text: 9,
            fontSize: 9,
            absolutePosition: { x: 352.5, y: 572 }
          },
          {
            //주택 오피스텔 외 상한요율
            text: 9,
            fontSize: 9,
            absolutePosition: { x: 209, y: 698 }
          }
        ],

        images: {
          contract1: this.imgPath + "/contract1.jpg",
          contract2: this.imgPath + "/contract2.jpg",
          contract3: this.imgPath + "/contract3.jpg"
        },
        styles: {
          docTitle: {}
        }
      };

      pdfMake.tableLayouts = {};

      // pdf 형식 다운로드
      //pdfMake.createPdf(docDefinition).download("test.pdf");
      pdfMake.createPdf(docDefinition).open();
    }
  },
  mounted() {},
  watch: {
    "pagination.currentPage"(newValue, oldValue) {
      this.getPropertyMgmt();
    },
    "pagination.perPage"(newValue, oldValue) {
      this.pagination.currentPage = 1;
      this.getPropertyMgmt();
    }
  }
};
</script>
<style>
.jipvio-dashboard .F_Menu .F_Menu_Select .el-radio {
  color: #5a2fca;
  border: 1px solid #5a2fca;
}

.jipvio-dashboard .F_Menu .F_Menu_Select .el-radio .el-radio__input {
  display: none;
}
.jipvio-dashboard .F_Menu .F_Menu_Select .el-radio.is-bordered.is-checked {
  background-color: #5a2fca;
}
.jipvio-dashboard
  .F_Menu
  .F_Menu_Select
  .el-radio__input.is-checked
  + .el-radio__label {
  color: #fff;
}
</style>
